import {SimpleMatrixAvalancheModel} from "../../../core/reel/simplereel/SimpleMatrixAvalancheModel";
import {SimpleReelModelDelegate, SimpleSymbolState} from "../../../core/reel/simplereel/SimpleReelModel";
import {MatrixUtils} from "../../utils/MatrixUtils";
import {TheCageStatics} from "../../config/TheCageStatics";
import {gsap} from "gsap";

export class FreeSpinsMatrixAvalancheModel extends SimpleMatrixAvalancheModel {

    constructor(columns:number, delegate:SimpleReelModelDelegate, triggerEvents:boolean = false) {
            super(columns, delegate, triggerEvents);
        }

    protected flipLeft(symbols:any[][]):any[][] {
        return [
            [symbols[0][2]],
            [symbols[0][1], symbols[1][2], symbols[2][2]],
            [symbols[0][0], symbols[1][1], symbols[2][1], symbols[3][1], symbols[4][1]],
            [symbols[1][0], symbols[2][0], symbols[3][0], symbols[4][0], symbols[5][1], symbols[6][2]],
            [symbols[5][0], symbols[6][1], symbols[7][2], symbols[8][2]],
            [symbols[6][0], symbols[7][1], symbols[8][1]],
            [symbols[7][0], symbols[8][0]],
        ]
    }

    protected flipBackFromLeft(symbols:any[][]):any[][] {
        return [
            [symbols[2][0], symbols[1][0], symbols[0][0]],
            [symbols[3][0], symbols[2][1], symbols[1][1]],
            [symbols[3][1], symbols[2][2], symbols[1][2]],
            [symbols[3][2], symbols[2][3]],
            [symbols[3][3], symbols[2][4]],
            [symbols[4][0], symbols[3][4]],
            [symbols[5][0], symbols[4][1], symbols[3][5]],
            [symbols[6][0], symbols[5][1], symbols[4][2]],
            [symbols[6][1], symbols[5][2], symbols[4][3]],
        ]
    }

    protected flipRight(symbols:any[][]):any[][] {
        return [
            [symbols[1][0], symbols[0][0]],
            [symbols[2][0], symbols[1][1], symbols[0][1]],
            [symbols[3][0], symbols[2][1], symbols[1][2], symbols[0][2]],
            [symbols[7][0], symbols[6][0], symbols[5][0], symbols[4][0], symbols[3][1], symbols[2][2]],
            [symbols[8][0], symbols[7][1], symbols[6][1], symbols[5][1], symbols[4][1]],
            [symbols[8][1], symbols[7][2], symbols[6][2]],
            [symbols[8][2]],
        ]
    }

    protected flipBackFromRight(symbols:any[][]):any[][] {
        return [
            [symbols[0][1], symbols[1][2], symbols[2][3]],
            [symbols[0][0], symbols[1][1], symbols[2][2]],
            [symbols[1][0], symbols[2][1], symbols[3][5]],
            [symbols[2][0], symbols[3][4]],
            [symbols[3][3], symbols[4][4]],
            [symbols[3][2], symbols[4][3]],
            [symbols[3][1], symbols[4][2], symbols[5][2]],
            [symbols[3][0], symbols[4][1], symbols[5][1]],
            [symbols[4][0], symbols[5][0], symbols[6][0]],
        ]
    }

    public dropOut():gsap.core.Timeline {
        if (this.dropOutTl && this.dropOutTl.isActive()){
            this.dropOutTl.seek("ending",false);
            delete this.dropOutTl;
        }

        const dropOutSymbols = MatrixUtils.cloneMatrix(this._symbols);
        this._symbols = [];

        const tl = gsap.timeline({
            onComplete:() => {
                this.clearSymbols(dropOutSymbols);
            }
        });

        for (let i:number = 0; i < dropOutSymbols.length; i++) {

            const startDelayIndex = Math.floor(i / 2);

            for (let j:number = 0; j < dropOutSymbols[i].length; j++) {
                const gapDelay = (i == 3 || i == 4 || i == 5) ? 1 : 0;

                const symbol = dropOutSymbols[i][j];
                const dropTl = gsap.timeline();
                dropTl.add(() => {
                    symbol.positionable.setAvalancheState(SimpleSymbolState.DROP_OUT);
                })
                dropTl.add(gsap.to(symbol.positionable.position, {
                    duration:TheCageStatics.DROP_OUT_DURATION,
                    x:this._symbolTargetPositions[i][j].x - TheCageStatics.STEP_WIDTH * 7,
                    y:this._symbolTargetPositions[i][j].y + TheCageStatics.STEP_HEIGHT * 7,
                    ease:"power1.in"
                }));

                tl.add(dropTl, TheCageStatics.SYMBOL_DROP_DELAY * (startDelayIndex + j + gapDelay));

            }
        }

        tl.addLabel("ending");
        tl.add(gsap.to(this, {duration:0.0001}));
        this.dropOutTl = tl;
        return tl;
    }
}